// extracted by mini-css-extract-plugin
module.exports = {"highlightAnimation":"SrGoingToMarketLiveCard--highlightAnimation--1n6-3","highlightYellowFadeIn":"SrGoingToMarketLiveCard--highlightYellowFadeIn--23OW2"};